
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';

import FAQ from './FAQ';
import UsePageTracking from '../components/usePageTracking';


function Tempotravelleronrentinpune() {



    const cardData =
    {
        keyword: 'Tempo Traveller on Rent in Pune',
        heading: 'Morya Cabs:  Tempo Traveller on Rent in Pune',
        headingDescription: 'Morya Cabs offers comfortable, spacious, and well-maintained Tempo Travellers for rent in Pune to cater to all your group travel needs. Whether you are planning a family trip, corporate outing, pilgrimage tour, or wedding transportation, our Tempo Travellers ensure a hassle-free and enjoyable journey. With professional drivers and top-notch amenities, we provide a seamless travel experience.',

        top: 'Popular Destinations to Hire a Tempo Traveller from Pune',

      "topPlaces": [
    {
        "title": "Pune to Mahabaleshwar",
        "description": "Enjoy a comfortable group trip to Mahabaleshwar, a popular hill station known for its lush greenery, waterfalls, and viewpoints. Our Tempo Traveller ensures a relaxed journey while you explore Venna Lake, Pratapgad Fort, and Mapro Garden."
    },
    {
        "title": "Pune to Shirdi",
        "description": "Planning a spiritual trip to Shirdi? Our Tempo Travellers offer a smooth journey to Sai Baba Temple, Dwarkamai, and Shani Shingnapur with ample space for your group to travel comfortably."
    },
    {
        "title": "Pune to Lonavala & Khandala",
        "description": "Experience a refreshing getaway to Lonavala and Khandala, famous for Bhushi Dam, Tiger’s Leap, and Karla Caves. Enjoy scenic road trips with our premium Tempo Traveller services."
    },
    {
        "title": "Pune to Goa",
        "description": "Heading to Goa for a vacation? Our luxury Tempo Traveller ensures a fun and enjoyable road trip with comfortable seating, luggage space, and AC facilities for a stress-free travel experience."
    },
    {
        "title": "Pune to Bhimashankar",
        "description": "Travel to Bhimashankar Temple, one of the 12 Jyotirlingas, with our well-equipped Tempo Traveller. The comfortable ride ensures a smooth journey through the lush green forests and hills."
    },
    {
        "title": "Pune to Alibaug",
        "description": "Perfect for beach lovers, our Tempo Traveller rental makes your Pune to Alibaug trip more enjoyable. Visit Kashid Beach, Kolaba Fort, and Murud-Janjira Fort with your group."
    },
    {
        "title": "Pune to Lavasa",
        "description": "For a peaceful retreat, book our Tempo Traveller to Lavasa, a picturesque town with beautiful landscapes, lakes, and adventure activities."
    },
    {
        "title": "Pune to Nashik",
        "description": "Visit the holy city of Nashik, home to Trimbakeshwar Temple, Sula Vineyards, and Panchavati with our spacious Tempo Traveller for a hassle-free trip."
    },
    {
        "title": "Pune to Tarkarli & Malvan",
        "description": "Enjoy a beachside vacation in Tarkarli, famous for scuba diving, water sports, and white sand beaches. Our Tempo Traveller offers ample space for luggage and a comfortable journey."
    },
    {
        "title": "Pune to Kolhapur",
        "description": "Travel to Kolhapur in a comfortable Tempo Traveller and explore Mahalaxmi Temple, Rankala Lake, and Panhala Fort."
    }
]
,



"services": [
    {
      "name": "17 Seater Tempo Traveller on Rent in Pune",
      "description": "Morya Cab offers a 17-seater tempo traveller on rent in Pune, perfect for group trips or family outings. Enjoy a comfortable ride with ample space for your group and luggage."
    },
    {
      "name": "13 Seater Tempo Traveller on Rent in Pune",
      "description": "For smaller group trips, Morya Cab provides a 13-seater tempo traveller on rent in Pune. Travel in comfort and style with our spacious vehicles and professional drivers."
    },
    {
      "name": "Traveller on Rent Pune",
      "description": "Morya Cab offers convenient traveller rental services in Pune for all your travel needs. Whether for a family trip, business outing, or religious journey, we have the right vehicle for you."
    },
    {
      "name": "Traveller Bus on Rent in Pune",
      "description": "Need a larger vehicle? Morya Cab provides traveller bus rentals in Pune, ideal for group travel or events. Our buses are comfortable and well-maintained, ensuring a smooth journey."
    },
    {
      "name": "17 Seater Bus Rate per Km in Pune",
      "description": "Morya Cab offers competitive rates for hiring a 17-seater bus in Pune. Get in touch for a detailed rate per km for your journey."
    },
    {
      "name": "17 Seater Tempo Traveller in Pune",
      "description": "Choose Morya Cab for a 17-seater tempo traveller in Pune. Whether for local sightseeing or outstation trips, we ensure comfort and convenience."
    },
    {
      "name": "17 Seater Tempo Traveller on Rent Pune",
      "description": "Rent a 17-seater tempo traveller from Morya Cab for a comfortable group ride in Pune. We offer affordable rates and high-quality service."
    },
    {
      "name": "20 Seater Tempo Traveller Pune",
      "description": "Looking for a 20-seater tempo traveller in Pune? Morya Cab offers spacious and well-maintained vehicles for group tours, family trips, or any large group travel needs."
    },
    {
      "name": "20 Seater Bus on Rent in Pune",
      "description": "Morya Cab offers 20-seater buses for rent in Pune. Whether for local or outstation travel, our buses provide the space and comfort you need for your journey."
    },
    {
      "name": "25 Seater Bus Rate per Km Pune",
      "description": "Morya Cab provides competitive rates for hiring a 25-seater bus in Pune. Reach out to us for pricing details and to book your ride."
    },
    {
      "name": "AC Tempo Traveller on Rent in Pune",
      "description": "Morya Cab offers AC tempo travellers on rent in Pune, ensuring a comfortable and cool journey, even during the warmer months. Perfect for both short and long trips."
    },
    {
      "name": "Book Tempo Online Pune",
      "description": "Booking a tempo online with Morya Cab is quick and easy. Choose from our fleet of tempo travellers for a smooth and enjoyable journey in Pune."
    },
    {
      "name": "Book Tempo Traveller in Pune",
      "description": "Book your tempo traveller in Pune with Morya Cab for a comfortable and reliable service. We offer a range of vehicles to suit your travel requirements."
    },
    {
      "name": "Hire Tempo in Pune",
      "description": "Morya Cab offers tempo hire services in Pune for all types of group trips. Whether you're going on a tour or need transport for an event, we have the right vehicle for you."
    },
    {
      "name": "Hire Tempo Traveller in Pune",
      "description": "Hiring a tempo traveller in Pune from Morya Cab ensures a comfortable and hassle-free ride. Choose the right size for your group and travel with peace of mind."
    },
    {
      "name": "Luxury Tempo Traveller on Rent in Pune",
      "description": "For those looking for a premium travel experience, Morya Cab offers luxury tempo travellers for rent in Pune. Enjoy enhanced comfort, extra space, and top-notch amenities."
    },
    {
      "name": "Pune Tempo Traveller Hire for Outstation",
      "description": "Morya Cab offers tempo traveller hire services for outstation trips from Pune. Whether it's a pilgrimage, business trip, or vacation, our vehicles provide the ideal solution."
    },
    {
      "name": "Pune to Mahabaleshwar Tempo Traveller",
      "description": "For your Pune to Mahabaleshwar journey, Morya Cab offers comfortable and reliable tempo travellers. Our professional drivers ensure a smooth ride, making your trip hassle-free."
    },
    {
      "name": "Pune to Shirdi Tempo Traveller Rate",
      "description": "Morya Cab offers competitive rates for tempo traveller services from Pune to Shirdi. Book with us for an affordable and comfortable pilgrimage journey."
    },
    {
      "name": "Tempo Traveller Hire in Pune",
      "description": "Morya Cab provides tempo traveller hire services in Pune, ensuring your group travels with comfort and ease. Choose from a range of vehicles based on your group size and requirements."
    },
    {
      "name": "Tempo Traveller on Rent in Pune Rate per Km",
      "description": "Morya Cab offers transparent pricing for tempo traveller rentals in Pune. Our rates are competitive and based on the distance traveled, ensuring great value for your trip."
    },
    {
      "name": "Tempo Traveller Rental Pune",
      "description": "For flexible and affordable tempo traveller rental in Pune, Morya Cab is the perfect choice. Book with us for a reliable and comfortable vehicle for your group travel."
    }
  ],



  tableData: [
    ["17 Seater Tempo Traveller on Rent in Pune", "-13 Seater Tempo Traveller on Rent in Pune"],
    ["Traveller on Rent Pune", "-Traveller Bus on Rent in Pune"],
    ["17 Seater Bus Rate per km in Pune", "-17 Seater Tempo Traveller in Pune"],
    ["17 Seater Tempo Traveller on Rent Pune", "-20 Seater Tempo Traveller Pune"],
    ["20 Seater Bus on Rent in Pune", "-25 Seater Bus Rate per km Pune"],
    ["AC Tempo Traveller on Rent in Pune", "-Book Tempo Online Pune"],
    ["Book Tempo Traveller in Pune", "-Hire Tempo in Pune"],
    ["Hire Tempo Traveller in Pune", "-Luxury Tempo Traveller on Rent in Pune"]
],

whychoose: [
    {
        "WhyChooseheading": "Reliable and On-Time Service",
        "WhyChoosedescription": "At Morya Cab, we value your time. Whether you're planning a group trip or an event, our Tempo Traveller service ensures punctual pickups and drop-offs, giving you a stress-free travel experience around Pune."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "Our Tempo Travellers are designed to provide maximum comfort for group travel. With ample space, air conditioning, and comfortable seating, you and your group will enjoy a smooth and pleasant journey."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are experienced and skilled at handling group travel. With an in-depth knowledge of Pune and surrounding areas, they ensure a safe, smooth, and efficient journey every time."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Morya Cab offers competitive, affordable, and transparent pricing for Tempo Traveller rentals in Pune. We provide a detailed breakdown of the costs upfront, ensuring no hidden charges."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Safety is our priority. Our Tempo Travellers are equipped with modern safety features, including seat belts, airbags, and GPS tracking, ensuring a secure and comfortable ride throughout your journey."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Morya Cab is available around the clock. Whether you're planning a trip in the early morning or late at night, we are always ready to serve you. Our customer service team is here to assist at any time."
    },
    {
        "WhyChooseheading": "Hassle-Free Booking Process",
        "WhyChoosedescription": "Booking a Tempo Traveller with Morya Cab is quick and easy. You can book online via our website or app, or you can contact our customer service team for personalized assistance."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "We offer customized packages to suit your needs, whether for sightseeing, business trips, or group events. Let us know your requirements, and we’ll tailor the journey to make it special."
    }
]













    }

    const faqData = [
        {
          question: "How can I book a Tempo Traveller on rent with Morya Cab?",
          answer: "Booking a Tempo Traveller is easy! You can reserve your vehicle online through our website or app, or contact our customer service team for personalized assistance."
        },
        {
          question: "Are the drivers experienced for group travel?",
          answer: "Yes, all our drivers are highly experienced in handling group travel, ensuring a safe and smooth journey for everyone."
        },
        {
          question: "What types of Tempo Travellers are available for rent?",
          answer: "We offer a variety of Tempo Travellers with different seating capacities, ensuring comfort for your group. From smaller groups to larger ones, we have options to suit your needs."
        },
        {
          question: "How do I pay for my Tempo Traveller rental?",
          answer: "We offer flexible payment options, including cash, credit/debit cards, and online payment via our app for your convenience."
        },
        {
          question: "Can I book a round trip for my Tempo Traveller rental?",
          answer: "Yes, we offer round trip bookings. Just provide us with your return details, and we’ll handle the rest."
        },
        {
          question: "Are there any extra charges for waiting or detours?",
          answer: "Any additional charges, such as for waiting time or detours, will be communicated upfront, ensuring complete transparency in pricing."
        },
        {
          question: "Can I hire a Tempo Traveller for sightseeing in Pune?",
          answer: "Yes, we offer sightseeing tours in Pune. Explore the city's top attractions with our experienced drivers."
        },
        {
          question: "What is the luggage allowance for a Tempo Traveller?",
          answer: "Our Tempo Travellers can comfortably accommodate standard luggage. If you have more luggage or specific requirements, please inform us during booking, and we will arrange accordingly."
        },
        {
          question: "Is Morya Cab available for corporate travel with a Tempo Traveller?",
          answer: "Yes, we offer corporate travel services, including group business trips and events, with our comfortable Tempo Travellers."
        },
        {
          question: "Why should I choose Morya Cab for Tempo Traveller rentals in Pune?",
          answer: "Morya Cab ensures a reliable, affordable, and comfortable journey for your group, with professional drivers, well-maintained vehicles, and excellent customer service. We guarantee a safe and enjoyable trip every time."
        }
      ];
      
      const testimonialData = [
        {
          id: 1,
          name: 'Mr. Amit Kulkarni',
          role: 'Family Traveler',
          review: "We rented a Tempo Traveller for a family trip to Lonavala, and it was a wonderful experience. The driver was professional, and the vehicle was clean and spacious. We had a comfortable journey, and the whole family enjoyed the trip!",
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        },
        {
          id: 2,
          name: 'Ms. Priya Shah',
          role: 'Corporate Executive',
          review: "We used Morya Cab’s Tempo Traveller service for a corporate event in Pune. The vehicle was perfect for our team, and the driver ensured that we had a smooth ride. The booking process was easy, and everything was well-coordinated.",
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        }
      ];
      
      
      
      
      
            
            
            
      











    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9371304510",
            "+91 8379975860",



        ],
        email: "booking@moryacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Shirdi Taxi",
            link: "/Pune-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Bhimashankar Taxi",
            link: "/Pune-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai Taxi",
            link: "/Pune-to-Mumbai-Taxi"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala Taxi",
            link: "/Pune-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mahabaleshwar Taxi",
            link: "/Pune-to-Mahabaleshwar-Taxi"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Aurangabad Taxi",
            link: "/Pune-to-Aurangabad-Taxi"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Nashik-Trimbakeshwar Taxi",
            link: "/Pune-to-Nashik-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Car Rental Services",
            link: "/Pune-Car-Rental-Services"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Ashtavinayak Taxi",
            link: "/Pune-to-Ashtavinayak-Taxi"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Goa Taxi",
            link: "/Pune-to-Goa-Taxi"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Solapur Taxi",
            link: "/Pune-to-Solapur-Taxi"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Hyderabad Cab",
            link: "/Pune-to-Hyderabad-Cab"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Kolhapur Taxi",
            link: "/Pune-to-Kolhapur-Taxi"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Bangalore Taxi",
            link: "/Pune-to-Bangalore-Taxi"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Indore Taxi",
            link: "/Pune-to-Indore-Taxi"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai to Shirdi Taxi",
            link: "/Mumbai-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Borivali to Pune Taxi Service",
            link: "/Borivali-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Vasai to Pune Taxi Service",
            link: "/Vasai-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Dombivli to Pune Taxi Services",
            link: "/Dombivli-to-Pune-Taxi-Services"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Dadar to Shirdi Taxi Service",
            link: "/Dadar-to-Shirdi-Taxi-Service"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Trimbakeshwar Taxi",
            link: "/Mumbai-to-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Bhimashankar Taxi",
            link: "/Mumbai-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai Central to Pune Taxi",
            link: "/Mumbai-Central-to-Pune-Taxi"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Thane to Pune Taxi Service",
            link: "/Thane-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Nashik Taxi",
            link: "/Mumbai-to-Nashik-Taxi"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Lonavala Taxi",
            link: "/Mumbai-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Mumbai Airport to Pune Taxi",
            link: "/Mumbai-Airport-to-Pune-Taxi"
        }
    ];


    const images = [
        { src: "/images/our-fleet/3.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/4.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/5.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/7.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/8.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/10.jpg", alt: "Image 1" },
       
    ];


   
    const jsonLD = {
        "@context": "https://schema.org",
        "@type": "RentalCarReservation",
        "name": "Tempo Traveller on Rent in Pune",
        "description": "Book Tempo Traveller in Pune for group travel, tours, and outstation trips. We offer 13-seater, 17-seater, 20-seater, and luxury options for rent.",
        "provider": {
          "@type": "Organization",
          "name": "Pune Tempo Traveller Rentals",
          "url": "https://www.punetempotravellers.com",
          "telephone": "+91-8888888888",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Plot No. 202, Viman Nagar, Pune",
            "addressLocality": "Pune",
            "addressRegion": "Maharashtra",
            "postalCode": "411014",
            "addressCountry": "IN"
          }
        },
        "offers": {
          "@type": "Offer",
          "priceCurrency": "INR",
          "price": 1500,
          "eligibleRegion": {
            "@type": "Place",
            "name": "Pune"
          },
          "priceValidUntil": "2025-12-31",
          "priceSpecification": {
            "@type": "PriceSpecification",
            "priceCurrency": "INR",
            "price": "1500",
            "valueAddedTaxIncluded": "false",
            "unitCode": "KM",
            "description": "Rate per km for 17-seater Tempo Traveller on Rent"
          }
        },
        "keywords": "Tempo Traveller on Rent Pune, 17 seater tempo traveller Pune, 20 seater tempo traveller Pune, Hire tempo in Pune, AC tempo traveller rental Pune, Pune tempo traveller booking, 13 seater tempo traveller Pune, Luxury tempo traveller rental, Tempo traveller on rent for outstation, Mahabaleshwar tempo traveller, Shirdi tempo traveller, Pune to Mahabaleshwar Tempo traveller"
      };
      

    return (
        <div>
            <UsePageTracking/>
<Helmet>
  <title>Tempo Traveller on Rent in Pune | Book Tempo for Outstation and Local Trips | Call: +91 9371304510</title>
  <meta
    name="description"
    content="Book a 13-seater, 17-seater, or 20-seater Tempo Traveller in Pune for your group travel needs. Affordable rental rates for local and outstation trips including Mahabaleshwar and Shirdi."
  />
  <meta
    name="keywords"
    content="Tempo Traveller on Rent Pune, 17 seater tempo traveller Pune, 20 seater tempo traveller Pune, Hire tempo in Pune, AC tempo traveller rental Pune, Pune tempo traveller booking, 13 seater tempo traveller Pune, Luxury tempo traveller rental, Tempo traveller on rent for outstation, Mahabaleshwar tempo traveller, Shirdi tempo traveller, Pune to Mahabaleshwar Tempo traveller"
  />
  <meta property="og:title" content="Tempo Traveller on Rent in Pune | Book Tempo for Outstation and Local Trips" />
  <meta
    property="og:description"
    content="Book a 13-seater, 17-seater, or 20-seater Tempo Traveller in Pune for your group travel needs. Affordable rental rates for local and outstation trips including Mahabaleshwar and Shirdi."
  />
  <meta property="og:url" content="https://www.punetempotravellers.com" />
  <meta property="og:type" content="website" />
  <meta property="og:image" content="https://www.punetempotravellers.com/images/tempo-traveller-pune.jpg" />
  <script type="application/ld+json">
    {JSON.stringify(jsonLD)}
  </script>
</Helmet>

            <div className="breadcumb-wrapper" style={{ backgroundImage: 'url(/img/bg/breadcumb-bg.jpg)' }}>
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/67.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                               style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Morya Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                                            {Images.map((e) => {
    return (
        <div className="box1" key={e.text}>
            <a
                href={e.link} // Use the separate link for each item
                className="d-flex justify-content-around align-items-center"
            >
                <div className="b1">
                    <img src={e.place} alt={e.text} />
                </div>
                <div className="b2">
                    <a href={e.link} className="px-3 colorr">{e.text}</a>
                </div>
            </a>
        </div>
    );
})}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #0AB4A9',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#0AB4A9' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 9371304510" className="d-block  text-white">+91 9371304510</a>
                                                <a href="tel:+91 8379975860" className="d-block  text-white">+91 8379975860</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@moryacab.com" className=" text-white d-block">
                                                    booking@moryacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Morya Cab<br />
                                                    Gat no. 763 Jai Ganesh Niwas Flat no. 1 Lokhande Wasti Chimbali Pune, Maharashtra 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Tempotravelleronrentinpune;